import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=8a184750&"
import script from "./Fullscreen.vue?vue&type=script&lang=ts&"
export * from "./Fullscreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports